import React, { ChangeEvent, useEffect, useState } from "react";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import SaveIcon from "@mui/icons-material/Save";
import EmailIcon from '@mui/icons-material/Email';
import BlockIcon from '@mui/icons-material/Block';
import ReplayIcon from '@mui/icons-material/Replay';
import IconButton from "@mui/material/IconButton";
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import TopoParceiro from "./topo";
import Parceiro from "../../components/classes/Parceiro";
import ParceiroDataSet from "../../components/data/parceiroDataset";
import UsuarioHelper from "../../helper/UsuarioHelper";
import PageHelper from "../../helper/pageHelper";
import { useParams } from 'react-router';
import { useNavigate } from "react-router-dom";
import EmailsParceiroModal from "./EmailsParceiroModal";
import { useTranslation } from "react-i18next";

const ParceiroDetalhe = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [containerId, setContainerId] = React.useState("xppd");
  const [openEmailsVinculados, setOpenEmailsVinculados] = React.useState(false);
  const [parceiro, setParceiro] = React.useState<Parceiro>(new Parceiro());
  const [open, setOpen] = React.useState(false);
  const dataSet: ParceiroDataSet = new ParceiroDataSet();
  const me: UsuarioHelper = new UsuarioHelper();
  const [emails, setEmails] = useState<string[]>([]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  useEffect(() => {
    loadParceiro();
  }, [id]);

  /* Component de Confirmação */
  const Mensagem = (titulo: string, mensagem: string, opt: Number) => {

    let buttons = [];

    switch (opt) {
      case 1:
        buttons = [
          { label: "Yes", onClick: () => handleAtualizaClick() },
          { label: "No", onClick: () => setOpen(false) },
        ];
        break;
      case 2:
        buttons = [
          { label: "Yes", onClick: () => handleBlockClick() },
          { label: "No", onClick: () => setOpen(false) },
        ];
        break;
      case 3:
        buttons = [{ label: "Ok", onClick: () => setOpen(false) }]
        break;
      case 4:
        buttons = [{
          label: "Ok", onClick: () => {
            setOpen(false);
            PageHelper.refreshPage();
          }
        }]
        break;
      default:
        buttons = [{ label: "Ok", onClick: () => setOpen(false) }]
        break;
    }

    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons
    });
  };

  const handleBlockClick = () => {
    dataSet.Bloquear(parceiro).then(() => {
      Mensagem(t("pages.partners.text.blockPartner"), t("pages.partners.text.blockSuccess"), 3);
      setParceiro({ ...parceiro, d_E_L_E_T_E: true })
    });
  }

  const handleUnblockClick = () => {
    dataSet.Desbloquear(parceiro);
    Mensagem(t("pages.partners.text.unlockPartner"), t("pages.partners.text.restoreSuccess"), 3);
    setParceiro({ ...parceiro, d_E_L_E_T_E: false })
  }

  const handleAtualizaClick = async () => {
    try {
      if (parceiro.id != 0) {

        parceiro.email = emails.join(';');
        let result = await dataSet.Atualizar(parceiro);

        if (result)
          Mensagem(t("pages.partners.text.savePartnerData"), t("pages.partners.text.updateSuccess"), 3);
        else
          throw t("pages.partners.text.updateFail");
      }
    } catch (err) {
      Mensagem(t("common.attention"), err + '', 3);
    }
  };

  const loadParceiro = async () => {
    let parcId = id ?? 0;
    let result = await dataSet.ObterPorId(+parcId);
    if (result) {
      setParceiro(result.data);
      if (result.data.email) {
        setEmails(result.data.email.split(';'));
      }
    }

  };

  const handlerApelidoChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, apelido: e.target.value, grupo: e.target.value };
    });
  };

  const handlerNomeChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, nome: e.target.value };
    });
  };

  const handlerCidadeChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, cidade: e.target.value };
    });
  };

  const handlerUFChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, uf: e.target.value };
    });
  };

  const handlerCEPChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, cep: e.target.value };
    });
  };

  const handlerEnderecoChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, endereco: e.target.value };
    });
  };

  const handlerPaisChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, pais: e.target.value };
    });
  };

  const handlerTelefoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, telefone: e.target.value };
    });
  };

  const handlerBairroChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, bairro: e.target.value };
    });
  };

  const handlerContatoChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, contato: e.target.value };
    });
  };

  const handlerTelefoneContatoChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, telefoneContato: e.target.value };
    });
  };

  const handlerCodigoClienteSAPChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, codigoClienteSAP: Number(e.target.value) };
    });
  };

  const handlerCodigoFornecedorSAPChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    setParceiro((previousState) => {
      return { ...previousState, codigoFornecedorSAP: Number(e.target.value) };
    });
  };

  const handlerSiteChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParceiro((previousState) => {
      return { ...previousState, site: e.target.value };
    });
  };

  const handleBackClick = () => {
    navigate(`/portal/parceiro`);
  }

  return (
    <React.Fragment>

      <Box className="container">
        <div className="containerTitle">
          <TopoParceiro />
        </div>
        <div className="containerToolbar" style={{ display: "flex", paddingTop: '8px', justifyContent: 'space-between' }}>
          <div style={{ marginLeft: '10px' }}>
            <Tooltip title={t("pages.partners.text.backToList")}>
              <IconButton onClick={handleBackClick}>
                <ArrowBackIosIcon />
              </IconButton>
            </Tooltip>
          </div>
          <div>
            <Tooltip title={t("pages.partners.text.partnerEmail")}>
              <IconButton onClick={() => setOpenEmailsVinculados(true)} > <EmailIcon /></IconButton>
            </Tooltip>
            <Tooltip title={t("pages.partners.text.partnerDataUpdate")}>
              <IconButton onClick={handleAtualizaClick} > <SaveIcon /></IconButton>
            </Tooltip>
            {me.ContemEssaRegra("ROOT") && parceiro.d_E_L_E_T_E === false && +parceiro.id > 0 ? (
              <Tooltip title={t("pages.partners.text.blockPartner")}>
                <IconButton onClick={handleBlockClick}> <BlockIcon /></IconButton>
              </Tooltip>
            ) : null}
            {me.ContemEssaRegra("ROOT") && parceiro.d_E_L_E_T_E === true && +parceiro.id > 0 ? (
              <Tooltip title={t("pages.partners.text.unlockPartner")}>
                <IconButton onClick={handleUnblockClick}> <ReplayIcon /></IconButton>
              </Tooltip>
            ) : null}
          </div>
        </div>
        <div className="insiderContainer">
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3} >
              <Grid item xs={12} sm={10}>
              </Grid>
              <Grid item xs={12} sm={2}>
              </Grid>
              <Grid item xs={12} sm={2} sx={{ display: 'none' }}>
                <TextField
                  required
                  id={containerId + "codigoClienteSAP"}
                  name={containerId + "codigoClienteSAP"}
                  label={t("pages.partners.text.sapCode")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.codigoClienteSAP}
                  onChange={handlerCodigoClienteSAPChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  required
                  id={containerId + "codigoFornecedorSAP"}
                  name={containerId + "CodigoFornecedorSAP"}
                  label={t("pages.partners.text.sapSupplier")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.codigoFornecedorSAP}
                  onChange={handlerCodigoFornecedorSAPChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  required
                  id={containerId + "apelido"}
                  name={containerId + "apelido"}
                  label={t("common.group")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.apelido}
                  onChange={handlerApelidoChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={7}>
                <TextField
                  required
                  id={containerId + "nome"}
                  name={containerId + "nome"}
                  label={t("common.name")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.nome}
                  onChange={handlerNomeChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <TextField
                  required
                  id={containerId + "endereco"}
                  name={containerId + "endereco"}
                  label={t("common.address")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.endereco}
                  onChange={handlerEnderecoChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id={containerId + "bairro"}
                  name={containerId + "bairro"}
                  label={t("common.neighborhood")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.bairro}
                  onChange={handlerBairroChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  required
                  id={containerId + "cidade"}
                  name={containerId + "cidade"}
                  label={t("common.city")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.cidade}
                  onChange={handlerCidadeChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <TextField
                  id={containerId + "estado"}
                  name={containerId + "estado"}
                  label={t("common.state")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.uf}
                  onChange={handlerUFChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <TextField
                  required
                  id={containerId + "cep"}
                  name={containerId + "cep"}
                  label={t("common.postalCode")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.cep}
                  onChange={handlerCEPChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  required
                  id={containerId + "pais"}
                  name={containerId + "pais"}
                  label={t("common.country")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.pais}
                  onChange={handlerPaisChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  required
                  id={containerId + "telefone"}
                  name={containerId + "telefone"}
                  label={t("common.phone")}
                  fullWidth
                  autoComplete="shipping phone"
                  variant="outlined"
                  value={parceiro.telefone}
                  onChange={handlerTelefoneChange}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  required
                  id={containerId + "contato"}
                  name={containerId + "contato"}
                  label={t("common.contact")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.contato}
                  onChange={handlerContatoChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  required
                  id={containerId + "contatoTelefone"}
                  name={containerId + "contatoTelefone"}
                  label={t("common.contactPhone")}
                  fullWidth
                  variant="outlined"
                  value={parceiro.telefoneContato}
                  onChange={handlerTelefoneContatoChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={9}>
                <TextField
                  required
                  id={containerId + "site"}
                  name={containerId + "site"}
                  label="Home Page"
                  fullWidth
                  variant="outlined"
                  value={parceiro.site}
                  onChange={handlerSiteChange}
                  size="small"
                />
              </Grid>
            </Grid>
          </form>
        </div>
      </Box>
      <EmailsParceiroModal openDialog={openEmailsVinculados} setOpenDialog={setOpenEmailsVinculados} emails={emails} setEmails={setEmails} />
    </React.Fragment>
  );
};

export default ParceiroDetalhe;
